import React, { useEffect, useState } from "react";
import { PageContainer, PageHeader, StatCard, Card } from "./Shared";
import { adminApi } from "./api";
import { ChartLine, EnvelopeOpen, Article, Briefcase } from "@phosphor-icons/react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/analytics/summary").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <PageContainer>
      <PageHeader title="Dashboard" subtitle="Overview of leads, traffic and content." />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Page Views (30d)" value={stats?.total_views ?? "—"} />
        <StatCard label="Unique Visitors" value={stats?.unique_visitors ?? "—"} />
        <StatCard label="Contact Leads" value={stats?.contact_leads ?? "—"} />
        <StatCard label="Career Applications" value={stats?.career_applications ?? "—"} />
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-5">
        <Card className="p-6">
          <div className="text-[11px] uppercase tracking-[0.16em] text-[#6B7A8D] font-semibold mb-3">Top sections</div>
          {stats?.top_sections?.length ? (
            <ul className="space-y-2">
              {stats.top_sections.map((s, i) => (
                <li key={i} className="flex items-center justify-between text-[13.5px]">
                  <span className="text-[#1C2B3A] capitalize">{s.section}</span>
                  <span className="text-[#6B7A8D] tabular-nums">{s.count}</span>
                </li>
              ))}
            </ul>
          ) : <div className="text-[13px] text-[#6B7A8D]">No data yet.</div>}
        </Card>

        <Card className="p-6">
          <div className="text-[11px] uppercase tracking-[0.16em] text-[#6B7A8D] font-semibold mb-3">Quick links</div>
          <div className="grid grid-cols-2 gap-3">
            {[
              ["/admin/blog", "Add a blog post", Article],
              ["/admin/leads", "View leads", EnvelopeOpen],
              ["/admin/jobs", "Post a job", Briefcase],
              ["/admin/analytics", "Open analytics", ChartLine],
            ].map(([href, label, Icon]) => (
              <a key={href} href={href}
                className="flex items-center gap-2.5 px-4 py-3 rounded-md border border-slate-200 hover:border-[#1B6FE0] hover:text-[#1B6FE0] transition text-[13.5px] font-medium">
                <Icon size={16} weight="duotone" /> {label}
              </a>
            ))}
          </div>
        </Card>
      </div>
    </PageContainer>
  );
}
